import { AnimatePresence, motion } from "framer-motion";

import { ReferralListItem } from "../../ReferralLinks.types";
import { ReferralField } from "./components/ReferralField/ReferralField";

export interface ReferralListProps {
  items: ReferralListItem[];
  expanded: boolean;
}

export const ReferralList: React.FC<ReferralListProps> = ({
  items,
  expanded,
}) => {
  if (items.length === 0) return null;

  const [firstField, ...remainingFields] = items;

  const renderItem = (props: ReferralListItem) => (
    <div key={props.code} className="flex gap-3">
      <ReferralField isLink value={props.link} disabled={props.disabled} />
      <ReferralField
        isLink={false}
        value={props.code}
        disabled={props.disabled}
      />
    </div>
  );

  return (
    <div className="flex flex-col gap-3">
      {firstField ? renderItem(firstField) : null}

      <AnimatePresence initial={false}>
        {expanded &&
          remainingFields.map((item) => (
            <motion.div
              key={item.code}
              exit={{ height: 0, opacity: 0 }}
              initial={{ height: 0, opacity: 0 }}
              animate={{ height: "auto", opacity: 1 }}
              transition={{ duration: 0.3, ease: "easeOut" }}
            >
              {renderItem(item)}
            </motion.div>
          ))}
      </AnimatePresence>
    </div>
  );
};
